
<template>
    
        <mars-view class="step-one"><mars-view class="box"><mars-view class="title">
            退款原因<mars-text class="tips">(必填)</mars-text></mars-view><mars-view class="textarea" @click.native="clickTextarea"><mars-textarea v-model="reason" class="textarea-container" :maxlength="500" :adjust-position="false" placeholder="请描述您的问题，以便我们帮您解决～" placeholder-style="font-size: 0.16rem"></mars-textarea><mars-view class="text-num">{{ reason.length }}<mars-text class="grey">/500</mars-text></mars-view></mars-view></mars-view><mars-view class="box"><mars-view class="title">
            图片补充说明<mars-text class="tips">(限3张)</mars-text></mars-view><mars-view class="pic-box"><mars-view class="pic-list"><upload-img :class="['upload', imgList.length >= 3 ? 'disable' : '']" :show-full="true" :max-img-num="3" :list="imgList" @startUpload="startUpload" @changeImage="changeImage"></upload-img><mars-view v-for="item, index in imgList" :key="index" class="pic-item"><mars-image mode="aspectFill" :src="item.url" class="image" @click.native="previewImage(item)"></mars-image><mars-view class="clear-icon" @click.native="handleClear(index)"></mars-view></mars-view></mars-view><mars-view class="tips">补充支付凭证或订单截图进行辅助说明，有利于退款订单的快速处理～</mars-view></mars-view></mars-view><mars-view class="box explain"><mars-view class="title">
            退款说明
        </mars-view><mars-view class="content"><mars-view v-for="item, index in explainList" :key="index" class="explain-item">
                {{ item }}
            </mars-view></mars-view></mars-view><mars-view :class="['submit', !reason || isUpdatePic ? 'disable' : '']" @click.native="submit">
        提交申请
    </mars-view></mars-view>
    
</template>

<script>
import upload from "../../components/common/upload.vue";
import { request } from '../../static/utils/request.js';
import { reqPathTo } from '../../static/utils/env.js';
import log from '../../static/utils/ubcLog';
export default {
  data() {
    return {
      reason: '',
      // 退款原因
      imgList: [],
      // 上传的图片
      explainList: ['1.支付成功后，律师将在24小时与您联系，在此期间暂不支持退款，如超过24小时律师还未与您取得联系，系统将自动退款', '2.收到申请后律师进行核实，确认无异议后处理退款', '3.咨询订单超过3天不予退款'],
      isSubmit: false,
      isUpdatePic: false // 是否在上传图片
    };
  },

  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  components: {
    'upload-img': upload
  },
  methods: {
    // 提交退款申请
    submit() {
      if (!this.reason) {
        this.$api.showToast({
          title: '请输入退款原因',
          icon: 'none'
        });
        return;
      }
      if (this.isUpdatePic) {
        this.$api.showToast({
          title: '请图片上传完成后再提交',
          icon: 'none'
        });
        return;
      }
      if (this.isSubmit) {
        return;
      }
      // 提交按钮点击打点
      log.send && log.send({
        serverId: 17167,
        action: 'click',
        area: 'submit-click'
      });
      this.isSubmit = true;
      let pics = this.imgList && this.imgList.map(item => item.url) || [];
      // 待联调
      request({
        url: reqPathTo('refund', {}, '', 'falv/order'),
        data: {
          order_id: this.orderId,
          reason: this.reason,
          pics: JSON.stringify(pics)
        },
        method: 'post',
        loginNeeded: false,
        needBduss: true,
        header: {
          'content-type': 'application/x-www-form-urlencoded'
        }
      }).then(res => {
        res = res && res.data;
        // 提交成功
        if (res && +res.status === 0) {
          this.$emit('submitSucc');
          this.$api.showToast({
            title: '提交成功',
            icon: 'none'
          });
          return;
        }
        this.$api.showToast({
          title: res && res.msg || '提交失败，请稍候再试~',
          icon: 'none'
        });
      }).finally(() => {
        this.isSubmit = false;
      });
    },
    /**
     * 图片改变
     * @param {Array} imageList 上传的图片列表
     */

    changeImage(imageList) {
      if (!imageList || !imageList.length) {
        return;
      }
      this.imgList = imageList;
      this.isUpdatePic = false;
    },
    /**
     * 预览图片
     * @param {String} url 预览的图片链接
     */

    previewImage({
      url
    }) {
      this.$api.previewImage({
        current: url,
        urls: this.imgList.map(item => item.url)
      });
    },
    /**
     * 删除图片
     * @param {Number} index 删除的图片下标
     */

    handleClear(index) {
      this.imgList.splice(index, 1);
    },
    startUpload() {
      this.isUpdatePic = true;
      log.send && log.send({
        serverId: 17167,
        action: 'click',
        area: 'fig-click'
      });
    },
    // 点击原因输入框
    clickTextarea() {
      log.send && log.send({
        serverId: 17167,
        action: 'click',
        area: 'reason-click'
      });
    }
  }
};
</script>

<style scoped>
.step-one textarea {
  outline: none;
}
.step-one .box {
  margin: 0 0.08rem;
  background: #fff;
  border: 0.5px solid #edf0fc;
  border-radius: 0.12rem;
  padding: 0.16rem 0.13rem;
  position: relative;
  z-index: 1;
}
.step-one .box:not(:first-child) {
  margin-top: 0.08rem;
}
.step-one .box.explain {
  padding-bottom: 0.11rem;
}
.step-one .box .title {
  font-family: PingFangSC-Medium;
  font-size: 0.17rem;
  color: #1e1f24;
  letter-spacing: 0;
  line-height: 1;
  font-weight: 500;
  margin-bottom: 0.14rem;
}
.step-one .box .title .tips {
  font-family: PingFangSC-Regular;
  font-size: 0.14rem;
  color: #848691;
  line-height: 1;
  font-weight: 400;
  margin-left: 0.08rem;
}
.step-one .box .textarea {
  height: 1.2rem;
  border: 0.5px solid #edf0fc;
  border-radius: 0.09rem;
  padding: 0.1rem 0.13rem 0.4rem;
  background: rgba(245, 246, 249, 0.7);
}
.step-one .box .textarea .textarea-container {
  background: rgba(245, 246, 249, 0.7);
  width: 100%;
  height: 100%;
  border: none;
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #1e1f24;
  line-height: 0.25rem;
  font-weight: 400;
  text-align: justify;
}
.step-one .box .textarea .text-num {
  text-align: right;
  font-size: 0.16rem;
  line-height: 0.16rem;
  margin-top: 0.11rem;
}
.step-one .box .textarea .text-num .grey {
  color: #848691;
}
.step-one .box .pic-box .pic-list {
  display: flex;
}
.step-one .box .pic-box .pic-list .upload {
  flex-shrink: 0;
  flex-grow: 0;
}
.step-one .box .pic-box .pic-list .pic-item {
  width: 0.89rem;
  height: 0.89rem;
  box-sizing: border-box;
  border-radius: 0.09rem;
  position: relative;
  border: 0.5px #edf0fc solid;
  flex-shrink: 0;
  flex-grow: 0;
}
.step-one .box .pic-box .pic-list .pic-item .image {
  width: 100%;
  height: 100%;
  border-radius: 0.09rem;
}
.step-one .box .pic-box .pic-list .pic-item:not(:last-child) {
  margin-right: 0.05rem;
}
.step-one .box .pic-box .pic-list .pic-item .clear-icon {
  height: 0.18rem;
  width: 0.18rem;
  position: absolute;
  right: 0.05rem;
  top: 0.05rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/clear-icon.png') no-repeat center center / 100% 100%;
}
.step-one .box .upload {
  width: 0.89rem;
  height: 0.89rem;
  border-radius: 0.09rem;
  position: relative;
  margin-right: 0.06rem;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/upload.png') no-repeat center center / 100% 100%;
}
.step-one .box .upload /deep/ .consult-form-content-img {
  height: 100%;
  width: 100%;
}
.step-one .box .upload.disable {
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/refund/upload-disable.png');
}
.step-one .box .explain-item {
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #50525c;
  line-height: 0.26rem;
  font-weight: 400;
  text-align: justify;
}
.step-one .box .explain-item:not(:first-child) {
  margin-top: 0.1rem;
}
.step-one .box .tips {
  font-family: PingFangSC-Regular;
  font-size: 0.16rem;
  color: #848691;
  margin-top: 0.07rem;
  line-height: 0.24rem;
  font-weight: 400;
}
.step-one .submit {
  height: 0.48rem;
  background: #05f;
  border-radius: 0.33rem;
  font-family: PingFangSC-Semibold;
  font-size: 0.18rem;
  color: #fff;
  text-align: center;
  line-height: 0.48rem;
  font-weight: 600;
  margin: 0.2rem 0.08rem 0.4rem;
}
.step-one .submit.disable {
  opacity: 0.5;
}

</style>
